import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '../../../core/Button';
import PageError from '../../../page/Error';
import useInstallation from '../../../apps/Installation/useInstallation';
import Center from './Center';
import Loader from './Loader';
import AppStatus from './AppStatus';
import AppNote from './AppNote';
import request from '../../../utils/request';
import useProvider from '../../../core/EcrionProvider/useProvider';
/**
 * @param {import('./types').MicroserviceInstallationServerStatusState} props
 */

var InstallationRedirect = function InstallationRedirect(_ref) {
  var redirect = _ref.redirect,
      serverState = _objectWithoutProperties(_ref, ["redirect"]);

  var _useProvider = useProvider(),
      routes = _useProvider.routes;

  React.useEffect(function () {
    //remove redirect from microserviceSettings to avoid infinite redirect loop
    request({
      method: 'POST',
      url: '/api/microservices/v1/settings',
      data: {
        Name: 'installation',
        Value: JSON.stringify(serverState)
      }
    }).then(function () {
      //internal redirect
      if (routes && routes.history) {
        routes.history.push(redirect);
      } else {
        throw new Error('Could not perform internal redirect because routes.history is missing from EcrionProvider');
      }
    });
  }, []);
  return null;
};

var Installation = function Installation(_ref2) {
  var installationUrl = _ref2.installationUrl,
      showResetToDefault = _ref2.showResetToDefault,
      appName = _ref2.appName,
      appIcon = _ref2.appIcon,
      FormComponent = _ref2.FormComponent,
      onSuccess = _ref2.onSuccess,
      history = _ref2.history;

  var _useInstallation = useInstallation({
    installationUrl: installationUrl,
    onSuccess: onSuccess
  }),
      userState = _useInstallation.userState,
      serverState = _useInstallation.serverState,
      progress = _useInstallation.progress,
      actions = _useInstallation.actions;

  var install = actions.install,
      uninstall = actions.uninstall,
      resetToDefault = actions.resetToDefault,
      dismissError = actions.dismissError,
      dismissIntention = actions.dismissIntention;
  if (userState.initializing) return React.createElement(Loader, null);

  if (!userState.errorDismissed && userState.error) {
    return React.createElement(PageError, {
      hideNavBar: true,
      dark: true,
      title: userState.error.title,
      message: userState.error.details,
      onClick: function onClick() {
        return dismissError();
      },
      buttonText: "Try again"
    });
  }

  if (userState.intentionCompleted) {
    if (userState.intention === 'INSTALL' || userState.intention === 'RESET' || userState.intention === 'UNINSTALL') {
      return React.createElement(Center, null, React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 4
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(AppStatus, {
        installation: serverState,
        appName: appName,
        appIcon: appIcon
      })), React.createElement(Grid, {
        item: true
      }, userState.intention === 'INSTALL' && React.createElement(Typography, {
        color: "inherit"
      }, "The app was installed successfully.", React.createElement("br", null), "Click the button below to start using the app:"), userState.intention === 'RESET' && React.createElement(Typography, {
        color: "inherit"
      }, "The app was reset successfully.", React.createElement("br", null), "Click the button below to start using the app:"), userState.intention === 'UNINSTALL' && React.createElement(Typography, {
        color: "inherit"
      }, "The app data was removed successfully.")), React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        variant: "contained",
        onClick: function onClick() {
          return dismissIntention();
        }
      }, "Continue"))));
    }
  }

  var actionState = null;

  if (showResetToDefault) {
    actionState = 'RESET';
  } else {
    if (serverState.status === 'INSTALLED' || serverState.status === 'UNINSTALL_ERROR' || serverState.status === 'UNINSTALLING') actionState = 'UNINSTALL';else if (serverState.status === 'UNINSTALLED' || serverState.status === 'INSTALL_ERROR' || serverState.status === 'MISSING') actionState = 'INSTALL';
  }
  /**
   * @param {import('./types').MicroserviceInstallationFormButtonsProp} ButtonProps
   */


  var CurrentButtons = function CurrentButtons(_ref3) {
    var onClick = _ref3.onClick;
    var buttons = null;

    var handleClick = function handleClick() {
      if (onClick) {
        onClick();
      } else {
        if (actionState === 'RESET') resetToDefault();else if (actionState === 'INSTALL') install();else if (actionState === 'UNINSTALL') uninstall();
      }
    };

    if (actionState === 'RESET') {
      buttons = React.createElement(Grid, {
        container: true,
        spacing: 2,
        justify: "center"
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        variant: "contained",
        disabled: serverState.status === 'RESTARTING' || serverState.status === 'INSTALLING' || serverState.status === 'UNINSTALLING',
        onClick: function onClick() {
          if (history) {
            if (history.returnEntries && history.returnEntries.length > 0) {
              history.goBack();
            } else {
              window.history.pushState('', '', '/');
              window.history.go();
            }
          } else {
            window.history.pushState('', '', '/');
            window.history.go();
          }
        }
      }, "Cancel")), React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        variant: "contained",
        color: "danger",
        disabled: serverState.status === 'RESTARTING' || serverState.status === 'INSTALLING' || serverState.status === 'UNINSTALLING',
        onClick: handleClick
      }, "Reset to Default")));
    } else if (actionState === 'UNINSTALL') {
      buttons = React.createElement(Button, {
        variant: "contained",
        color: "danger",
        onClick: handleClick,
        pendingPromise: "Uninstalling"
      }, "Uninstall");
    } else if (actionState === 'UNINSTALLING') {
      buttons = React.createElement(Button, {
        disabled: true,
        variant: "contained",
        color: "danger"
      }, "Uninstalling");
    } else if (actionState === 'INSTALL') {
      buttons = React.createElement(Button, {
        variant: "contained",
        onClick: handleClick,
        pendingPromise: "Installing"
      }, "Install");
    }

    return buttons;
  };

  var CurrentAppNote = function CurrentAppNote() {
    return React.createElement(AppNote, {
      installation: serverState,
      isResetToDefault: showResetToDefault
    });
  };

  var CurrentAppStatus = function CurrentAppStatus() {
    return React.createElement(AppStatus, {
      installation: serverState,
      progress: progress,
      appName: appName,
      appIcon: appIcon
    });
  };

  return React.createElement(Center, null, serverState.redirect && (serverState.status === 'INSTALLED' || serverState.status === 'UNINSTALLED') && React.createElement(InstallationRedirect, serverState), FormComponent ? React.createElement(FormComponent, {
    installation: serverState,
    actions: actions,
    actionState: actionState,
    components: {
      Buttons: CurrentButtons,
      AppStatus: CurrentAppStatus,
      AppNote: CurrentAppNote
    }
  }) : React.createElement(React.Fragment, null, React.createElement(CurrentAppStatus, null), React.createElement(CurrentAppNote, null), React.createElement(CurrentButtons, null)));
};

Installation.defaultProps = {
  installationUrl: '/api/installation',
  showResetToDefault: false,
  appName: undefined,
  appIcon: undefined,
  form: null,
  onSuccess: null
};
export default Installation;